// Change this value to update both the polling interval and the on-screen label.
export const ACS_EVENTS_REFRESH_INTERVAL_SECONDS: number = 10;
